import React, { Fragment } from "react";
import useForm from "react-hook-form";
import { connect } from "react-redux";
import store from "store";
import ImageUpload from "./imageUpload";

import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
const ProductForm = (props) => {
  const { register, handleSubmit, errors } = useForm(); // initialise the hook
  console.log("Props", {props})
  var {
    info,
    onChangeProductUrl,
    searchProductUrl,
    searchUrlStatus,
    productList,
    onChangeProductId,
    isEdit,

    imageUrl,
    onChangeImage,
    removeImage,
  } = props;

  const onSubmit = (data) => {
    if (data !== "") {
      // onSubmitForm()/
      props.onClickConfirm(data);
    } else {
      errors.showMessages();
    }
  };

  return (
    <Fragment>
      <div className="container-fluid">
        <div className="card-body">
          <form
            id="product-form"
            className="needs-validation"
            noValidate=""
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row ">
              <div className="col-md-2 col-md-offset-3  "></div>
              <div className="col-md-8 text-center  ">
                <ImageUpload
                  imageUrl={imageUrl}
                  onChangeImage={onChangeImage}
                  removeImage={removeImage}
                  uploadType={"question"}
                />
              </div>
            </div>

            <div className="form-row">
              {/* <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                  Banner Title
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="title"
                    type="text"
                    defaultValue={info.title || ""}
                    placeholder="title"
                    ref={register({ required: true })}
                  />
                  <span>{errors.title && "Title is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>
              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                  Banner Sub-title
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="subTitle"
                    type="text"
                    defaultValue={info.subTitle || ""}
                    placeholder="Sub Title"
                    ref={register({ required: true })}
                  />
                  <span>{errors.subTitle && "Sub Title is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div> */}

              <div className="col-md-12 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
                  Select Category
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <Typeahead
                    id="basic-typeahead"
                    labelKey={(option) => `${option.name}`}
                    selected={
                      info.productId &&
                      productList.filter((item) => item._id === info.productId)
                    }
                    multiple={false}
                    options={productList}
                    onInputChange={(input) => console.log({ input })}
                    // onChange={value => console.log({ value })}
                    onChange={(value) =>
                      value.length > 0 && onChangeProductId(value[0]["_id"])
                    }
                    name="product"
                    ref={register({
                      required: true,
                    })}
                    placeholder="Choose a category..."
                  />
                  <span style={{ color: "#ff5370" }}>
                    {errors.product && "Category is required"}
                  </span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>
            </div>
            <div className="float-end">
              <button className="btn btn-primary" type="submit" style={{padding:"6px 28px", fontSize:"14px"}}>
                {isEdit ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};
export default connect()(ProductForm);
